import type { GlobalContext } from '@/model/globalcontext.model';

let ref: GlobalContext | null = null;

export function registerAppGlobalContext(ctx: GlobalContext): void {
  ref = ctx;
}

export function getAppGlobalContext(): GlobalContext | null {
  return ref;
}
